var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class PanasonicProjectorRs232 {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: '\x02ADZZ;QPW',
                next: /\x02(\d+)/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.displayBlank = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\x02ADZZ;QSH`, /\x02(\d+)/i, tags);
                return parseInt(match[1], 10) === 1;
            }),
            set: (blank, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\x02ADZZ;OSH:${blank ? '1' : '0'}`, /\x02OSH:(\d+)/i, tags);
                return parseInt(match[1], 10) === 1;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\x02ADZZ;QVX:SVRS0`, /\x02SVRS0=(.+)/i, tags);
                return match[1];
            }),
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\x02ADZZ;QPW`, /\x02(\d+)/i, tags);
                return parseInt(match[1], 10) === 1;
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\x02ADZZ;P${power ? 'ON' : 'OF'}`, /\x02PO([N|F])/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 6000);
                return match[1] === 'N';
            }),
        };
        this.serialNumber = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\x02ADZZ;QSN`, /\x02(.+)/i, tags);
                return match[1];
            }),
        };
        this.videoInput = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\x02ADZZ;QIN`, /\x02(...)/i, tags);
                return match[1];
            }),
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\x02ADZZ;IIS:${code}`, /\x02IIS:(...)/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 2000);
                return match[1];
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\x02ADZZ;QAV`, /\x02(...)/, tags);
                return parseInt(match[1], 10);
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\x02ADZZ;AVL:${volume.toString().padStart(3, '0')}`, /\x02AVL:(\d+)/, tags);
                return parseInt(match[1], 10);
            }),
            range: { max: 63, min: 0, round: 1 },
            powerOffRestrictions: ['get', 'set'],
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\x02ADZZ;QMT`, /\x02(\d+)/, tags);
                return parseInt(match[1], 10) === 1;
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\x02ADZZ;AMT:${mute ? '1' : '0'}`, /\x02AMT:(\d+)/i, tags);
                return parseInt(match[1], 10) === 1;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            {
                intervalMs: 3000,
                controls: ['displayBlank', 'power', 'videoInput', 'volume', 'volumeMute'],
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
PanasonicProjectorRs232.driverType = 'socketDriver';
PanasonicProjectorRs232.key = '-LWVuYtXFO3gV2S45arc';
PanasonicProjectorRs232.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\x03'],
    },
    sendTerminator: '\x03',
};
PanasonicProjectorRs232.socketOptions = [
    Object.assign(Object.assign({}, PanasonicProjectorRs232.baseSocketOptions), { port: 4999 }),
];
